import { combineReducers } from 'redux';

import infra from '#/modules/infra/redux/infraSlice';

const rootReducer = combineReducers({
  infra,
});

export default rootReducer;
